import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideMic = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M12 19v3m7-12v2a7 7 0 0 1-14 0v-2" />
      <rect width={6} height={13} x={9} y={2} rx={3} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideMic);
const Memo = memo(ForwardRef);
export default Memo;
